/**
 * Aviso de uso didático, exibido em todas as oficinas de cálculo.
 *
 * As oficinas usam modelos simplificados e um catálogo de ensino; na
 * ocorrência real valem as ferramentas e guias oficiais.
 */
export const AVISO_DIDATICO =
  'Ferramenta de ensino — não substitui ALOHA/CAMEO, o GRE (ERG) nem o Manual ABIQUIM na ocorrência real.'

export const AVISO_DIDATICO_CURTO = 'Uso didático — não substitui ALOHA/GRE'
